__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "react-ecommerce-catalogue-page";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("axios", "1.2.1", function() { return Promise.all([__webpack_require__.e(64), __webpack_require__.e(889)]).then(function() { return function() { return __webpack_require__(64); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(747)]).then(function() { return function() { return __webpack_require__(164); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(791); }; }); });
			register("web-vitals", "2.1.4", function() { return __webpack_require__.e(787).then(function() { return function() { return __webpack_require__(787); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};